import {
    GoabCircularProgress,
    GoabContainer,
    GoabIconButton,
    GoabTooltip,
} from "@abgov/react-components";
// import { getClaims, useAuthUser } from "../apis/auth";
import "./Home.css";
import {hasResourceRole} from "../apis/tokenUtil";
import {useAuth} from "react-oidc-context";
import {appList} from "../apis/constants";

export const Home = () => {
    const auth = useAuth();
    const isAuthorized = () => {
        const res =
            appList.filter((item) =>
                hasResourceRole(
                    item.resource as string,
                    item.permission as string[],
                    auth.user?.access_token as string,
                ),
            ).length > 0;
        return res;
    };
    // const AppAccessList = (list: typeof appList) =>
    //   list
    //     .filter(item =>
    //       hasResourceRole(
    //         item.resource as string,
    //         item.permission as string[],
    //         auth.user?.access_token ?? ""
    //       )
    //     )
    //     .map((item, index) => ({
    //       id: index,
    //       label: item.label,
    //       resource: item.resource,
    //       enableLink: item.enableLink,
    //       toolTipText: item.toolTipText,
    //       img: item.img,
    //       url: item.url,
    //     }));

    // // Step 1: Build primary app list
    // let appsAccess = AppAccessList(appList);

    // // Step 2: Check if Aviation app exists - if user have a "Aviation" app access not need to add Terms of Hire app.
    // const aviationExist = appsAccess.some(x => x.label === "Aviation");

    // // Step 3: If user not have access "Aviation" app then add "Terms of Hire" app and merge both lists
    // if (!aviationExist) {
    //   appsAccess = [
    //     ...AppAccessList(appSubList),
    //     ...appsAccess
    //   ].map((item, index) => ({ ...item, id: index }));
    // }
    // const isAuthorized =  appsAccess.length > 0;

    return (
        <>
            <div className="content">
                <h1>Alberta Wildfire Applications Portal</h1>
                {auth.isLoading && <GoabCircularProgress visible={true} />}
                {!auth.isLoading && auth.isAuthenticated && (
                    <div className="grid">
                        {appList
                            .filter((item) =>
                                hasResourceRole(
                                    item.resource as string,
                                    item.permission as string[],
                                    auth.user?.access_token as string,
                                ),
                            )
                            .map((item, index) => (
                                <div key={index} className="app-container">
                                    <section className="item-wrapper">
                                        <GoabContainer
                                            padding="compact"
                                            type="non-interactive"
                                            accent="thin"
                                        >
                                            <section className="tooltip-wrapper">
                                                <GoabTooltip
                                                    content={item.toolTipText}
                                                    position="bottom"
                                                >
                                                    <GoabIconButton
                                                        size="medium"
                                                        icon="help-circle"
                                                    ></GoabIconButton>
                                                </GoabTooltip>
                                            </section>
                                            <section className="link-wrapper">
                                                <img
                                                    src={item.img}
                                                    width="24"
                                                    height="24"
                                                    title={item.label}
                                                    alt={item.label}
                                                />
                                                {item.enableLink && (
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={item.url}
                                                    >
                                                        {item.label}
                                                    </a>
                                                )}
                                                {!item.enableLink && (
                                                    <span>
                                                        &nbsp;{item.label}
                                                    </span>
                                                )}
                                            </section>
                                        </GoabContainer>
                                    </section>
                                </div>
                            ))}
                    </div>
                )}
                {!auth.isLoading && auth.isAuthenticated && !isAuthorized() && (
                    <NotAuthorized />
                )}
            </div>
        </>
    );
};

const NotAuthorized = () => {
    return (
        <p>
            You are currently unable to access any applications in the portal
            because no user roles are assigned to you. For access, please
            contact one of the following: your supervisor, your Area's Regional
            Administrator, your Wildfire Management Branch contact, or Wildfire
            Applications Support via&nbsp;
            <a href="/#">wildfire.applications@gov.ab.ca</a> or +1 780-427-8100
        </p>
    );
};
